import { Component } from "react";
import Popup from "..";
import RectButton from "../../ui/button/RectButton";
import Input from "../../ui/Input";

class SavePopup extends Component {
    render() {
        return (
            <Popup className="save-template">
                <div className="column">
                    <Input placeHolder="Name of your template" />
                    <RectButton text="CREATE TEMPLATE" />
                </div>
            </Popup>
        )
    }
}

export default SavePopup;